import React from 'react';
import microsoftTeamsLogo from './microsoft-teams-logo.png';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

function MicrosoftTeamsLogo({ ...props }) {
  const { tr } = useTranslation();
  return <img src={microsoftTeamsLogo} alt={tr('perform.logos.microsoft_teams.alt')} {...props} />;
}

export default MicrosoftTeamsLogo;
